// Polish (`pl`) shell baseline
import { layoutPl } from './pl/layout'
import { homePl } from './pl/home'
import { playPl } from './pl/play'
import { demoPl } from './pl/demo'
import { booksPl } from './pl/books'
import { commercePl } from './pl/commerce'
import { communityPl } from './pl/community'
import { dashboardPl } from './pl/dashboard'
import { authPl } from './pl/auth'
import { marketingPl } from './pl/marketing'
import { worldPl } from './pl/world'
import { encyclopediaPl } from './pl/encyclopedia'
import { systemPl } from './pl/system'
import { cityPl } from './pl/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const basePl: MessageCatalog = {
  ...layoutPl,
  ...homePl,
  ...playPl,
  ...demoPl,
  ...booksPl,
  ...commercePl,
  ...communityPl,
  ...dashboardPl,
  ...authPl,
  ...marketingPl,
  ...worldPl,
  ...encyclopediaPl,
  ...systemPl,
  ...cityPl,
}
